import { BaseElementWidget, FormDateTimeRangeFieldWidget, SPI, ViewType, Widget } from '@kunlun/dependencies';
import moment from 'moment';

@SPI.ClassFactory(
  BaseElementWidget.Token({
    viewType: ViewType.Form,
    widget: 'DateTimeRangePicker'
  })
)
export class MyDateTimeRangePickerWidget extends FormDateTimeRangeFieldWidget {
  @Widget.Reactive()
  protected get showTimeDefaultValue() {
    return [moment('00:00:00', this.timeFormat || 'HH:mm:ss'), moment('23:59:59', this.timeFormat || 'HH:mm:ss')];
  }
}
